import { useForceExitStore } from "../stores/forceExitStore";

interface CheckForceExitResult {
  shouldForceExit: boolean;
  canProceed: boolean;
}

/**
 * Hook for components to check if force-exit is active before making mutations.
 * If force-exit is active, the caller should display the force-exit modal instead
 * of proceeding with the save operation.
 * @returns {CheckForceExitResult} Object with shouldForceExit and canProceed flags.
 */
export function useCheckForceExit(): CheckForceExitResult {
  const shouldForceExit = useForceExitStore((state) => state.shouldForceExit);

  return {
    shouldForceExit,
    canProceed: !shouldForceExit,
  };
}
